/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import DiscoverPlansCard from './discoverPlansCard';
import { plansAction } from '../../reducers/PublicAPIData';
import { AddItemToCart, getCartAction } from '../../reducers/cartItemData';

function DiscoverPlans() {
  // const [scrollPosition, setScrollPosition] = useState(0);
  // const plansContainerRef = useRef(null);

  // const handleScroll = (direction) => {
  //   const container = plansContainerRef.current;

  //   if (container) {
  //     const scrollAmount = window.innerWidth / 2; // You can adjust this value based on your design
  //     const newScrollPosition =
  //       direction === 'left'
  //         ? scrollPosition - scrollAmount
  //         : scrollPosition + scrollAmount;

  //     container.scrollTo({
  //       left: newScrollPosition,
  //       behavior: 'smooth',
  //     });

  //     setScrollPosition(newScrollPosition);
  //   }
  // };

  const plans = useSelector(
    (state) => state.PublicAPIDataReducer.allActivePlans
  );

  const cartItemDataFromStore = useSelector(
    (state) => state.CartItemReducer.cartItems
  );

  const dispatch = useDispatch();

  const getOneCart = () => {
    if (cartItemDataFromStore.length !== 0) {
      dispatch(getCartAction({ orderUID: cartItemDataFromStore.orderUID }));
    }
  };

  const cartLineItemsFromStore = useSelector(
    (state) => state.CartItemReducer.cartItems.lineItems
  );

  const AddOneLineItemToCart = async (id) => {
    dispatch(
      AddItemToCart({
        orderUID: cartItemDataFromStore.orderUID,
        planUID: id,
      })
    ).then((res) => {
      if (res.meta.requestStatus === 'fulfilled') {
        getOneCart();
      }
    });
  };

  useEffect(() => {
    dispatch(plansAction());
  }, []);

  return (
    <div className='container my-5'>
      <h3 className='fw-bold ms-3 mt-3 text-center'>Plans</h3>
      <div className='d-flex overflow-hidden justify-content-between align-items-center'>
        <div className='col-12 pb-2 d-flex mt-3' style={{ overflowX: 'auto' }}>
          {plans.map(
            (plan) =>
              plan.sellable === 'call' &&
              plan.showOnDiscoverFeed &&
              plan.type !== 'stock' &&
              plan.type !== 'single' && (
                <DiscoverPlansCard
                  plan={plan}
                  cartLineItemsFromStore={cartLineItemsFromStore}
                  AddOneLineItemToCart={AddOneLineItemToCart}
                  key={plan.planUID}
                />
              )
          )}
        </div>
      </div>
      <h6 className='text-center mt-3'>
        <Link to='/view-all-plans' className='int-text'>
          View All Plans
        </Link>
      </h6>
      {plans.length === 0 && (
        <h6 className='text-center fs-5 text-danger'>
          No Plans available at moment
        </h6>
      )}
    </div>
  );
}
export default DiscoverPlans;
